import { createFileRoute } from "@tanstack/react-router";
import WhatIsTms from "@/pages/WhatIsTms";
export const Route = createFileRoute("/contents/tms/what-is-tms-therapy")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Is TMS Therapy? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn what Transcranial Magnetic Stimulation is. FDA-cleared, non-invasive, drug-free depression treatment in Coral Springs, FL. Discover benefits and.",
        },
        {
          property: "og:title",
          content: "What Is TMS Therapy? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn what Transcranial Magnetic Stimulation is. FDA-cleared, non-invasive, drug-free depression treatment in Coral Springs, FL. Discover benefits and.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/tms/what-is-tms-therapy",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/tms/what-is-tms-therapy",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsTms />;
}
